export default {
  sm: `
  NBP’s global network has main points of 
  presence building global regions 
  throughout the world. Thanks to LINE used
  by hundreds of millions of people around 
  the world, you can rely on the global 
  platform with proven reliability.    
  `,
  md: `
  NBP’s global network has main points of 
  presence building global regions throughout 
  the world. Thanks to LINE used by hundreds 
  of millions of people around the world, you 
  can rely on the global platform with proven 
  reliability.    
  `,
  lg: `
  NBP’s global network has main points of presence building 
  global regions throughout the world. Thanks to LINE used 
  by hundreds of millions of people around the world, you 
  can rely on the global platform with proven reliability.    
  `,
  xxl: `
  NBP’s global network has main points of 
  presence building global regions throughout 
  the world. Thanks to LINE used by hundreds 
  of millions of people around the world, you can 
  rely on the global platform with proven 
  reliability.    
  `,
};
